<div class="file-icon" [class]="'file-icon file-icon--' + fileType">
	<lucide-icon [name]="getIconName()" [size]="20"></lucide-icon>
	<span class="file-icon__ext">{{ getFileExtension() }}</span>
</div>
